import { Component, OnInit } from '@angular/core';
import { UserService } from '../../shared/services/user.service';

@Component({
  selector: 'app-the-grove',
  templateUrl: './the-grove.component.html',
  styleUrls: ['./the-grove.component.scss']
})
export class TheGroveComponent implements OnInit {

  scrollContent: any[] = [];

  constructor(public userService: UserService) { }

  ngOnInit(): void {
    this.createScrollContent();
  }

  createScrollContent(): void {
    const phrases = [
      "Welcome to The Grove",
      "Connection",
      "Support", 
      "Growth",
      "Community",
      "Wellness",
      "Opportunity",
      "Fun Ambassadors",
      "Loyalty Rewards",
      "Join The Grove"
    ];
    
    this.scrollContent = [];
    for (let i = 0; i < 6; i++) { // Repeat 6 times to ensure no gaps
      phrases.forEach((phrase, index) => {
        this.scrollContent.push({
          phrase: phrase,
          key: `scroll-${i}-${index}`
        });
      });
    }
  }

  isLoggedIn() {
    if (
      Object.keys(this.userService.userServiceModal.customerData).length &&
      this.userService.userServiceModal.customerData.CustomerId &&
      this.userService.checkIfUserAuthenticatedOrNot()
    ) {
      return true;
    } else {
      return false;
    }
  }

} 